module.exports = __webpack_public_path__ + "static/media/ahref.4246af10.png";